import type { FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { Controller } from 'react-hook-form';

import { CircleCheckBigIcon } from 'lucide-react';

import type { SelectOption } from '@/components/ui/select';
import { i18n } from '@/lib/i18n';

export const FieldValid = <T extends FieldValues>({
  name,
  label,
  methods,
  options,
  type,
}: {
  name: Path<T>;
  label: string;
  methods: UseFormReturn<T>;
  options?: SelectOption[];
  type?: 'square';
}) => {
  return (
    <Controller
      {...methods}
      name={name}
      render={({ field: { value } }) => {
        return (
          <div className="flex items-center gap-2">
            <CircleCheckBigIcon size={20} className="text-success" />
            <div className="space-y-0.5">
              <p className="text-base font-semibold leading-tight">{label}</p>
              <p className="text-base leading-tight text-text-secondary">
                {options
                  ? options.find(({ id }) => String(id) === String(value))?.title
                  : type === 'square'
                    ? i18n.t('area-value', { value })
                    : value}
              </p>
            </div>
          </div>
        );
      }}
    />
  );
};
